import React from 'react';
import { graphql, HeadProps, PageProps } from 'gatsby';
import { Kfh_AreaType } from '../../types/graphqlTypes';
import LocationCouncilTax from '../../components/locations/LocationCouncilTax';
import { SEO } from '../../components/Seo';

interface AreaPageProps {
  area: Kfh_AreaType;
}
const AreaCouncilTaxPage = ({ data }: PageProps<AreaPageProps>) => <LocationCouncilTax location={data.area} />;

export default AreaCouncilTaxPage;

export const Head = ({ data }: HeadProps<AreaPageProps>) => {
  const seo = data.area.seoPages.find((seoPage) => seoPage.remoteTypeName === 'KfhSeoAreaGuideCouncilTaxType');
  return <SEO data={seo} />;
};

export const pageQuery = graphql`
  query AreaCouncilTaxPageQuery($id: String!) {
    area: kfhAreaType(id: { eq: $id }) {
      id
      name
      relativeUrl
      artirixMultiSearch
      artirixDisplayName
      region {
        name
        relativeUrl
      }
      relatedBoroughs {
        edges {
          node {
            name
            councilTaxModel {
              previousTaxYear
              currentTaxYear
              rateChange
              direction
              councilTaxBands {
                name
                tax
                year
              }
              taxBands {
                band
                direction
                lastYear
                rateChange
                thisYear
              }
            }
          }
        }
      }
      seoPages {
        ... on KFH_KfhSeoAreaGuideCouncilTaxType {
          id
          h1
          htmlDescription
          metaAuthor
          metaCopyright
          metaDescription
          metaKeywords
          noIndex
          onSiteMap
          priority
          remoteTypeName
          slug
          title
          noFollow
        }
      }
    }
  }
`;
